/* eslint-disable import/no-anonymous-default-export */
import * as React from 'react';
import {
    FilterList,
    FilterLiveSearch,
    FilterListItem,
    useGetIdentity,
    useGetList,
} from 'react-admin';
import { Box, Chip } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import { endOfYesterday, startOfWeek, startOfMonth, subMonths } from 'date-fns';

import { Status } from '../misc/Status';
import { useConfigurationContext } from '../root/ConfigurationContext';

export const ContactListFilter = () => {
    const { noteStatuses } = useConfigurationContext();
    const { identity } = useGetIdentity();
    const { data } = useGetList('scmtags', {
        pagination: { page: 1, perPage: 10 },
        filter: { tipo: "fornecedor" },
        sort: { field: 'descricao_tag', order: 'ASC' },
    });
    return (
        <Box width="13em" minWidth="13em" order={-1} mr={2} mt={5}>
            <FilterLiveSearch
                hiddenLabel
                sx={{
                    display: 'block',
                    '& .MuiFilledInput-root': { width: '100%' },
                }}
                placeholder="Pesquisar"
            />
            <FilterList label="Última atividade" icon={<AccessTimeIcon />}>
                <FilterListItem
                    label="Hoje"
                    value={{
                        'data_hora@gte': endOfYesterday().toISOString(),
                        'data_hora@lte': undefined,
                    }}
                />
                <FilterListItem
                    label="Esta semana"
                    value={{
                        'data_hora@gte': startOfWeek(new Date()).toISOString(),
                        'data_hora@lte': undefined,
                    }}
                />
                <FilterListItem
                    label="Este mês"
                    value={{
                        'data_hora@gte': startOfMonth(new Date()).toISOString(),
                        'data_hora@lte': undefined,
                    }}
                />
                <FilterListItem
                    label="Anteriores"
                    value={{
                        'data_hora@gte': undefined,
                        'data_hora@lte': startOfMonth(new Date()).toISOString(),
                    }}
                />
            </FilterList>
            <FilterList label="Temperatura" icon={<TrendingUpIcon />}>
                {noteStatuses.map(status => (
                    <FilterListItem
                        key={status.value}
                        label={
                            <>
                                {status.label} <Status status={status.value} />
                            </>
                        }
                        value={{ temperatura: status.value }}
                    />
                ))}
            </FilterList>
            <FilterList label="Tags" icon={<LocalOfferIcon />}>
                {data &&
                    data.map(record => (
                        <FilterListItem
                            key={record.id}
                            label={
                                <Chip
                                    label={record?.descricao_tag}
                                    size="small"
                                    style={{
                                        backgroundColor: record?.color,
                                        border: 0,
                                        cursor: 'pointer',
                                    }}
                                />
                            }
                            value={{ 'id_tag': record.id }}
                        />
                    ))}
            </FilterList>
            <FilterList label="Tarefas" icon={<AssignmentTurnedInIcon />}>
                <FilterListItem
                    label="Pendentes"
                    value={{ 'com_tarefas': true }}
                />
            </FilterList>
            <FilterList
                label="Vendedor"
                icon={<SupervisorAccountIcon />}
            >
                <FilterListItem label="Eu" value={{ cod_vendedor: identity?.id }} />
            </FilterList>
        </Box>
    );
};
